module.exports = __webpack_public_path__ + "img/002-artist.d16ff7be.png";